import { render, staticRenderFns } from "./spectrum-hero.vue?vue&type=template&id=e4e705ca&scoped=true"
import script from "./spectrum-hero.vue?vue&type=script&lang=js"
export * from "./spectrum-hero.vue?vue&type=script&lang=js"
import style0 from "./spectrum-hero.vue?vue&type=style&index=0&id=e4e705ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e705ca",
  null
  
)

export default component.exports